import { FORM__CHANGE_CREATE_PROJECT_INPUT } from '.';
export const changeCreateProjectInput = _ref => {
  let {
    name,
    value
  } = _ref;
  return {
    type: FORM__CHANGE_CREATE_PROJECT_INPUT,
    payload: {
      name,
      value
    }
  };
};